<template lang="pug">
  .store
    v-layout.my-6(v-if="!settings")
      v-row.fill-height.ma-0(align='center' justify='center')
        v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
    .content(v-else)
      .background-header.white
        v-container.white.px-4(style="max-width:600px")
          v-layout.mt-2
            v-avatar.mr-4(size="100px")
              v-img(:src="settings.profile_image ? settings.profile_image.file : require('@/assets/image_placeholder.png')")
            v-col.pa-0
              .h6.basic800--text.mb-2 {{ settings.name || company.name }}
              div(style="word-break: break-all")
                a.p1.info500--text(:href="getShareLinkURL" target="_blank" style="text-decoration: none") {{ getShareLinkURL }}
              v-row.mt-4(no-gutters)
                v-col.pr-1
                  v-btn.button-AA-small(color="textColorAccent" block outlined x-small height="32" :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}" @click="openEditYezzaStore =! openEditYezzaStore") {{ $t('edit') }}
                v-col.pl-1
                  v-btn.button-AA-small(color="textColorAccent" block outlined x-small height="32" :style="{'background-color': $vuetify.theme.themes[$theme].textColorAccent}" @click="shareSheet =! shareSheet")
                    div.basic100--text {{ $t('share') }}

      v-container.px-4(v-if="Auth('component', '/admin/yezza-store#settings')" style="max-width:600px")
        .s1.primary400--text {{ $t('store_settings') }}
        v-card.my-3.mt-2(flat :outlined="$vuetify.breakpoint.smAndDown ? false : true")
          //- v-layout(@click="openYezzaPages" style="cursor: pointer;")
          //-   v-layout.mt-1(style="height: 56px; max-width: 30px; min-width: 30px; margin-right: 12px;")
          //-     eva-icon.ma-auto(name="copy-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
          //-   v-layout.py-4
          //-     div.my-auto
          //-       v-layout
          //-         .s1.basic800--text Store Pages
          //-         v-chip.ml-2.my-auto.font-weight-bold(color="premium" label x-small dark) Premium
          //-       .c1.basic600--text Create landing page for your Yezza store
          //- v-divider.basic300
          v-layout(@click="openYezzaStoreThemes = true" style="cursor: pointer")
            v-layout.mt-1(style="height:56px; max-width:56px; min-width:56px;")
              eva-icon.ma-auto(name="layout-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
            v-layout.py-4
              div.my-auto
                .s1.basic800--text {{ $t('yezza_store_layouts') }}
                .c1.basic600--text {{ $t('yezza_store_layouts_desc') }}
          v-divider.basic300
          v-layout(@click="openManageProductCategory = true" style="cursor: pointer")
            v-layout.mt-1(style="height:56px; max-width:56px; min-width:56px;")
              eva-icon.ma-auto(name="grid-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
            v-layout.py-4
              div.my-auto
                .s1.basic800--text {{ $t('product_categories') }}
                .c1.basic600--text {{ $t('product_categories_desc') }}
          v-divider.basic300
          v-layout(@click="openYezzaStoreDialog = true" style="cursor: pointer")
            v-layout.mt-1(style="height:56px; max-width:56px; min-width:56px;")
              eva-icon.ma-auto(name="clipboard-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
            v-layout.py-4
              div.my-auto
                .s1.basic800--text {{ $t('checkout_form') }}
                .c1.basic600--text {{ $t('checkout_form_desc') }}
          v-divider.basic300
          template(v-if="company.genes.find(g => g.feature === 'business_hours')")
            v-layout(@click="openBusinessHour = true" style="cursor: pointer")
              v-layout.mt-1(style="height:56px; max-width:56px; min-width:56px;")
                eva-icon.ma-auto(name="clock-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
              v-layout.py-4
                div.my-auto
                  .s1.basic800--text {{ $t('business_hour') }}
                  .c1.basic600--text {{ $t('business_hour_desc') }}
            v-divider.basic300
          v-layout(@click="openAddPromoBanner = true" style="cursor: pointer")
            v-layout.mt-1(style="height:56px; max-width:56px; min-width:56px;")
              SpeakerphoneIcon.ma-auto(size="24" :style="{ 'color': $vuetify.theme.themes[$theme].basic700 }")
            v-layout.py-4
              div.my-auto
                .s1.basic800--text {{ $t('promo_banner') }}
                .c1.basic600--text {{ $t('promo_banner_desc') }}
          v-divider.basic300
          v-layout
            v-layout.mt-1(style="height:56px; max-width:56px; min-width:56px;")
              eva-icon.ma-auto(name="message-square-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
            v-col.pa-0.my-auto
              v-layout.py-4
                div.my-auto.pr-2
                  .s1.basic800--text {{ $t('sales_pop_up') }}
                  .c1.basic600--text {{ $t('sales_pop_up_desc') }}
            v-col.pa-0.shrink.mt-5
              y-switch.my-0.py-0(v-model="salesPop")
          //- v-divider.basic300
          //- v-layout
            v-layout.mt-1(style="height:56px; max-width:56px; min-width:56px;")
              //- eva-icon.ma-auto(name="slash-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
              BuildingWarehouseIcon.ma-auto(size="26" :style="{ 'color': $vuetify.theme.themes[$theme].basic700 }")
            v-col.pa-0.my-auto
              v-layout.py-4
                div.my-auto.pr-2
                  .s1.basic800--text In Stock Quantity
                  .c1.basic600--text Show your product stock quantity
            v-col.pa-0.shrink.mt-5
              y-switch.my-0.py-0(v-model="showProductStock")
          v-divider.basic300
          v-layout
            v-layout.mt-1(style="height:56px; max-width:56px; min-width:56px;")
              eva-icon.ma-auto(name="slash-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
            v-col.pa-0.my-auto
              v-layout.py-4
                div.my-auto.pr-2
                  .s1.basic800--text {{ $t('sold_out_products') }}
                  .c1.basic600--text {{ $t('sold_out_products_desc') }}
            v-col.pa-0.shrink.mt-5
              y-switch.my-0.py-0(v-model="hideSoldOut")
          v-divider.basic300
          v-layout(@click="openProductsInventoryVisibilityDialog = true" style="cursor: pointer")
            v-layout.mt-1(style="height:56px; max-width:56px; min-width:56px;")
              BuildingWarehouseIcon.ma-auto(size="24" :style="{ 'color': $vuetify.theme.themes[$theme].basic700 }")
            v-layout.py-4
              div.my-auto
                .s1.basic800--text {{ $t('products_inventory_visibility') }}
                .c1.basic600--text {{ $t('products_inventory_visibility_desc') }}
          v-divider.basic300
          template(v-if="company.genes.find(g => g.feature === 'min_order_amount')")
            v-layout(@click="openMinAmountDialog = true" style="cursor: pointer")
              v-layout.mt-1(style="height:56px; max-width:56px; min-width:56px;")
                eva-icon.ma-auto(name="shopping-cart-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
              v-layout.py-4
                div.my-auto
                  .s1.basic800--text {{ $t('minimum_order_amount') }}
                  .c1.basic600--text {{ $t('minimum_order_amount_desc') }}
            v-divider.basic300
          v-layout(v-if="zones.length > 0" @click="openStoreZonesDialog = true" style="cursor: pointer")
            v-layout.mt-1(style="height:56px; max-width:56px; min-width:56px;")
              eva-icon.ma-auto(name="car-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
            v-layout.py-4
              div.my-auto
                .s1.basic800--text {{ $t('manage_shipping_zones') }}
                .c1.basic600--text {{ $t('manage_shipping_zones_desc') }}
          v-divider.basic300
          v-layout(@click="openRequestCustDomain = true" style="cursor: pointer")
            v-layout.mt-1(style="height:56px; max-width:56px; min-width:56px;")
              eva-icon.ma-auto(name="globe-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
            v-layout.py-4
              div.my-auto
                .s1.basic800--text {{ $t('custom_domain') }}
                .c1.basic600--text {{ $t('custom_domain_desc') }}
          v-divider.basic300

      .modals
        edit-yezza-store(v-if="openEditYezzaStore" :open.sync="openEditYezzaStore" :settings.sync="settings")
        manage-product-category(v-if="openManageProductCategory" :open.sync="openManageProductCategory" :company="company")
        yezza-store-form(v-if="openYezzaStoreDialog" :open.sync="openYezzaStoreDialog" :company="company" :form.sync="settings.form" :settings.sync="settings")
        request-custom-domain(v-if="openRequestCustDomain" :open.sync="openRequestCustDomain" :company="company")
        add-promo-banner(v-if="openAddPromoBanner" :open.sync="openAddPromoBanner" :company="company" :settings.sync="settings" @banner="settings.banner = $event")
        add-business-hour(v-if="openBusinessHour" :open.sync="openBusinessHour" :company="company" :settings.sync="settings" @bhour="settings.business_hours = $event")
        yezza-store-themes(v-if="openYezzaStoreThemes" :open.sync="openYezzaStoreThemes" :link="getStoreURL")
        edit-min-order-amount(v-if="openMinAmountDialog" :open.sync="openMinAmountDialog" :company="company" :settings.sync="settings" @minamount="settings.min_amount = $event")
        edit-products-inventory-visibility(v-if="openProductsInventoryVisibilityDialog" :open.sync="openProductsInventoryVisibilityDialog" :company="company" :settings.sync="settings")
        edit-store-zones(v-if="openStoreZonesDialog" :open.sync="openStoreZonesDialog" :company="company" :form="settings.form" :szones="zones")
        y-dialog.white(v-model='openPrintQR')
          v-card
            v-row.pt-3(no-gutters align="center")
              v-col(cols="8" offset="2" align="center")
                v-chip(color="black" :to="`/print-qr?link=${this.company.slug}&store=true`" target="_blank" link outlined small)
                  | {{ $t('print') }}
                  v-icon.ml-2(small) mdi-cloud-print-outline
              v-col.pr-3(cols="2" align="center")
                v-btn(icon small @click="openPrintQR = false; shareSheet = false")
                  v-icon mdi-close
            v-card(align="center" flat)
              div.d-flex.justify-center.align-center(style="position: absolute; height: 100%; width: 100%")
                img(:src="require('@/assets/images/icon_yezza_qr.png')" style="width: 75px")
              vue-qrcode(:value="getShareLinkURL" :options="{ width: 270 }")
        y-bottom-sheet(v-model='shareSheet' inset)
          v-card.py-4(flat)
            div.mx-6.s2.primary400--text {{ $t('share_store_link') }}
            v-list.pa-0
              v-list-item(@click="shareUrlToSocial('whatsapp')")
                v-list-item-avatar.my-0
                  v-icon(color="#455A64" size="24") fab fa-whatsapp
                v-list-item-title.s2.basic1000--text WhatsApp
              v-list-item(@click="shareUrlToSocial('facebook')")
                v-list-item-avatar.my-0
                  v-icon(color="#3b5998" size="24") fab fa-facebook
                v-list-item-title.s2.basic1000--text Facebook
              v-list-item(@click="copyUrl" v-clipboard:copy="getShareLinkURL")
                v-list-item-avatar.my-0
                  v-icon(size="24") mdi-content-copy
                v-list-item-title.s2.basic1000--text {{ $t('copy_url') }}
                  div.c1.primary400--text {{ getShareLinkURL }}
              v-list-item(@click="openPrintQR = true")
                v-list-item-avatar.my-0
                  v-icon(size="24") mdi-qrcode
                v-list-item-title.s2.basic1000--text {{ $t('print_qr_code') }}

</template>

<script>
import { mapState, mapActions } from 'vuex'
import EditYezzaStore from '@/components/dialogs/EditYezzaStore.vue'
import ManageProductCategory from '@/components/dialogs/ManageProductCategory.vue'
import RequestCustomDomain from '@/components/dialogs/RequestCustomDomain.vue'
import AddBusinessHour from '@/components/dialogs/AddBusinessHour.vue'
import AddPromoBanner from '@/components/dialogs/AddPromoBanner.vue'
import YezzaStoreThemes from '@/components/dialogs/YezzaStoreThemes.vue'
import ProductCategoryItem from '@/components/ProductCategoryItem.vue'
import YezzaStoreForm from '@/components/dialogs/YezzaStoreForm.vue'
import EditStoreZones from '@/components/dialogs/EditStoreZones.vue'
import EditMinOrderAmount from '@/components/dialogs/EditMinOrderAmount.vue'
import EditProductsInventoryVisibility from '@/components/dialogs/EditProductsInventoryVisibility.vue'
import VueQrcode from '@chenfengyuan/vue-qrcode'

export default {
  name: 'YezzaStore',
  components: { 
    EditYezzaStore,
    ManageProductCategory,
    ProductCategoryItem,
    YezzaStoreForm,
    VueQrcode,
    RequestCustomDomain,
    AddBusinessHour,
    AddPromoBanner,
    YezzaStoreThemes,
    EditStoreZones,
    EditMinOrderAmount,
    EditProductsInventoryVisibility
  },
  props: ['company'],
  data: () => ({
    settings: null,
    openEditYezzaStore: false,
    openManageProductCategory: false,
    openYezzaStoreDialog: false,
    openStoreZonesDialog: false,
    openRequestCustDomain: false,
    openAddPromoBanner: false,
    openBusinessHour: false,
    openMinAmountDialog: false,
    openProductsInventoryVisibilityDialog: false,
    openYezzaStoreThemes: false,
    shareSheet: false,
    openPrintQR: false,
    salesPop: false,
    hideSoldOut: false,
    showProductStock: false,
    zones: [],
    customDomainURL: null
  }),
  computed: {
    ...mapState('user', ['member']),
    getStoreURL () {
      if (this.customDomainURL) {
        return `https://${this.customDomainURL}/`
      }
      return `https://${this.company.slug}.${process.env.VUE_APP_STORE_URL_DOMAIN}/`
    },
    getShareLinkURL () {
      let url = this.getStoreURL
      if (this.member.role === 'Agent') {
        url += `?aid=${this.member.id}`
      }
      return url
    },
  },
  watch: {
    salesPop (val) {
      if (val !== this.settings.salespop) {
        this.$axios.patch(`/store/settings/${this.company.slug}/`, { salespop: val })
        .then(() => {
          this.showMessage(['success', this.$t('success_message.sales_popup_updated')])
          this.settings.salespop = val
        })
        .catch(() =>{
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
      }
    },
    hideSoldOut (val) {
      if (val !== this.settings.hide_soldout) {
        this.$axios.patch(`/store/settings/${this.company.slug}/`, { hide_soldout: val })
        .then(() => {
          this.showMessage(['success', this.$t('success_message.successfully_updated')])
          this.settings.hide_soldout = val
        })
        .catch(() =>{
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
      }
    },
    showProductStock (val) {
      if (val !== this.settings.show_stock) {
        this.$axios.patch(`/store/settings/${this.company.slug}/`, { show_stock: val })
        .then(() => {
          this.showMessage(['success', this.$t('success_message.successfully_updated')])
          this.settings.show_stock = val
        })
        .catch(() =>{
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
      }
    }
  },
  mounted () {
    this.fetchSettings()
    this.fetchZones()
    this.fetchDomain()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchSettings() {
      this.$axios.get(`/store/settings/${this.company.slug}/?expand=form`)
      .then((response) => {
        this.settings = response.data
        this.salesPop = response.data.salespop
        this.hideSoldOut = response.data.hide_soldout
        this.showProductStock = response.data.show_stock
      })
      .catch(() => {
        let params = {
          company : this.company.id,
          name : `${this.company.slug} - store`,
          email_enabled : false,
          email_required : false,
          layout : 'inquiry',
          extra_fields : [],
          type: 'store'
        }
        this.$axios.post(`/forms/`, params)
        .then((response) => {
          params = {
            company : this.company.id,
            name: '',
            form: response.data.id
          }
          this.$axios.post(`/store/settings/`, params)
          .then(() => {
            this.fetchSettings()
          }).catch(() => {})
        }).catch(() => {})
      })
    },
    fetchZones () {
      this.$axios.get(`/shipping/settings/${this.company.slug}/zones/?page_size=-1`)
      .then((response) => {
        this.zones = response.data.results || []
      }).catch(() => {})
    },
    fetchDomain() {
      this.$axios.get(`/domains/?company=${this.company.id}`)
      .then((response) => {
        let domain = response.data.results.filter(f => f.enabled && f.mode.includes(2))
        if (domain.length > 0) {
          this.customDomainURL = domain[0].name
        }
      })
      .catch(() =>{})
    },
    openYezzaPages () {
      if (this.$store.state.subscriptions.feature === 'personal' && this.company.contract) {
        this.showMessage(['upgrade'])
        return
      }
      this.$router.push('/admin/yezza-store/pages')
    },
    copyUrl() {
      this.showMessage(['success', this.$t('success_message.link_copied_to_clipboard')])
      this.shareSheet = false
    },
    shareUrlToSocial(platform) {
      if (platform == 'whatsapp') {
        window.open(`https://api.whatsapp.com/send?text=${this.getShareLinkURL}`, '_blank')
      } else if (platform == 'facebook') {
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${this.getShareLinkURL}`, '_blank')
      } else if (platform === 'twitter' ) {
        window.open(`http://twitter.com/share?url=${encodeURIComponent(this.getShareLinkURL)}`, '_blank')
      }
    },
  }
}
</script>

<i18n>
{
  "en": {
    "store_settings": "Store settings",
    "yezza_store_layouts": "Yezza Store Layouts",
    "yezza_store_layouts_desc": "Choose your preferred layout",
    "product_categories": "Product Categories",
    "product_categories_desc": "Set your product categories",
    "checkout_form": "Checkout Form",
    "checkout_form_desc": "Collect data from your customer",
    "business_hour": "Business Hour",
    "business_hour_desc": "Set open and close time of your store",
    "promo_banner": "Promo Banner",
    "promo_banner_desc": "Create your promo banner",
    "sales_pop_up": "Sales Pop-up",
    "sales_pop_up_desc": "Show recent buyer from your Yezza Store",
    "sold_out_products": "Sold Out Products",
    "sold_out_products_desc": "Hide your sold out products",
    "products_inventory_visibility": "Products inventory visibility",
    "products_inventory_visibility_desc": "Show your current product inventory level",
    "minimum_order_amount": "Minimum Order Amount",
    "minimum_order_amount_desc": "Set minimum order amount for checkout",
    "manage_shipping_zones": "Manage Shipping Zones",
    "manage_shipping_zones_desc": "Manage shipping zones for Yezza Store",
    "custom_domain": "Custom domain",
    "custom_domain_desc": "Buy or use your own domain for Yezza Store",
    "share_store_link": "Share Store Link by"
  },
  "id": {
    "store_settings": "Pengaturan Toko",
    "yezza_store_layouts": "Layout Toko Yezza",
    "yezza_store_layouts_desc": "Pilih Layout Favoritmu",
    "product_categories": "Kategori Produk",
    "product_categories_desc": "Tulis nama kategori produk",
    "checkout_form": "Form Checkout",
    "checkout_form_desc": "Data yang disimpan dari pelanggan",
    "business_hour": "Jam Kerja Bisnis",
    "business_hour_desc": "Tentukan jam kerja bisnes kamu",
    "promo_banner": "Promo Banner",
    "promo_banner_desc": "Buat promo banner",
    "sales_pop_up": "Pop-up Penjualan",
    "sales_pop_up_desc": "Tampilkan pembeli terbaru dari Toko Yezzamu",
    "sold_out_products": "Produk Produk yang Habis ",
    "sold_out_products_desc": "Sembunyikan Produkmu yang Sold Outs",
    "products_inventory_visibility": "Tampilan Inventaris produk",
    "products_inventory_visibility_desc": "Tunjukkan tingkat inventaris produk kamu saat ini",
    "minimum_order_amount": "Jumlah Pesanan Minimum",
    "minimum_order_amount_desc": "Atur jumlah minimal pesanan untuk checkout",
    "manage_shipping_zones": "Atur Zona Pengiriman",
    "manage_shipping_zones_desc": "Atur Zona Pengiriman untuk toko",
    "custom_domain": "Domain khusus",
    "custom_domain_desc": "Beli atau gunakan domain kamu sendiri untuk Yezza Store",
    "share_store_link": "Bagikan link Toko"
  }
}
</i18n>
